import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";
import { useWindow } from "./useWindow";
import { useApi } from "./useAPI";
import isDev from "@utils/isDev";
import { mockLocalizationFile } from "../../client/mocks/mockLocalizationFile";
const useLoadLocalizations = () => {
    const myWindow = useWindow();
    const { getItem, setItem } = useLocalStorage();
    const { get } = useApi();
    const getMockLocalizations = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockLocalizationFile);
            }, 1000);
        });
    };
    const getLocalHash = () => {
        const localizations = getItem("localizations");
        return localizations === null || localizations === void 0 ? void 0 : localizations.hash;
    };
    const fetchLocalizations = async () => {
        const localHash = getLocalHash();
        const query = localHash ? new URLSearchParams({ hash: localHash }).toString() : "";
        return get(`api/siteconfiguration?${query}`).json();
    };
    const initTranslations = async () => {
        try {
            let localizations;
            if (isDev()) {
                localizations = await getMockLocalizations();
            }
            else {
                localizations = await fetchLocalizations();
            }
            setItem("localizations", localizations);
            myWindow.dispatchEvent(new Event("storage"));
        }
        catch (error) {
            console.log("Hash updated.");
        }
    };
    useEffect(() => {
        myWindow && initTranslations();
    }, [myWindow]);
    return {
        initTranslations
    };
};
export default useLoadLocalizations;
